import {
  BUTTON_SUBMISSION,
  BIA_MY_ACCOUNT,
  BIA_FILTER_BY,
  BIA_SEARCH,
  BIA_CARD_VIEW,
  BIA_TABLE_VIEW,
  NOT_APPLICABLE,
  STASH,
  ATC,
  PRODUCT_POD,
  SECTION,
  RECS_CART_ADDITION_INFO,
  OVERLAY,
  CART_ADDITION_INFO,
  BIA_PAGE_TYPE,
  MY_ACCOUNT_SETTINGS,
  CART_ADD_RECS
} from '../constants';

export const buyItAgain = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.timeFilter', ({ output }) => {
    const { timeFilter = '' } = output;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: BIA_FILTER_BY + `${timeFilter}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.search', ({ output }) => {
    const { dateRange = '', searchFilter = '', searchTerm = '' } = output;
    const searchBy = dateRange + ':' + searchFilter;
    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: BIA_SEARCH,
        searchTerm,
        searchBy
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.pageView', ({ output }) => {
    const { view = 'Grid' } = output;
    const settings = view === 'Grid' ? BIA_CARD_VIEW : BIA_TABLE_VIEW;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.quantityChange', ({ output }) => {
    const { type } = output; // field, up, down
    
    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: `buy it again: quantity change: ${ type === 'field' ? 'quantity field': `increment ${ type } button`}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-again.addToCart', ({ output }) => {
    const {
      sku,
      displayPosition,
      recommendationType,
      strategy,
      recommendationVersion,
    } = output;

    const pageType = digitalData?.page?.pageInfo?.pageType || '';
    
    const ddoEvent = {
      category: {
          primaryCategory: STASH
      },
      eventInfo: {
        eventName: RECS_CART_ADDITION_INFO
      },
      eventMode: STASH,
      stash: {
        component: PRODUCT_POD,
        pageType,
        section: SECTION,
        sharedSection: NOT_APPLICABLE,
        target: ATC,
        item: [
          {
            productInfo: {
              sku
            },
            displayPosition,
            recommendation: {
              recommendationType,
              pageType,
              anchorProductSku: NOT_APPLICABLE,
              strategy: strategy || NOT_APPLICABLE,
              recommendationVersion: recommendationVersion || NOT_APPLICABLE,
              featureVersion: NOT_APPLICABLE,
              interval: NOT_APPLICABLE
            }
          }
        ],
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-again.componentScroll', ({ output }) => {
    const { direction = '' } = output;
    const pageType = digitalData?.page?.pageInfo?.pageType || '';

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: `buy it again component: ${pageType}: scroll arrow ${direction}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.viewAllLink', () => {
    const pageType = digitalData?.page?.pageInfo?.pageType || '';

    const DDOEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: `buy it again component: ${pageType}: view all link`,
        }
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-again.quickView', ({ output }) => {
    
    const DDOEvent = {
      category: {
        primaryCategory: OVERLAY,
      },
      eventInfo: {
        eventName: 'buy it again product quickview',
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.quickviewLink', () => {
    const DDOEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: "buy it again: product quickview link click",
        }
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-again.cartAdditionOverlay', ({ output }) => {
    const { items = [], sharedSection } = output
    const eventItems = items.map(item => ({
      displayPosition: NOT_APPLICABLE,
      productInfo: { sku: item.sku || '' }
    }));

    const DDOEvent = 
    {
      category: {
        primaryCategory: STASH,
      },
      eventInfo: {
        eventName: CART_ADDITION_INFO,
      },
      eventMode: STASH,
      stash: {
        component: "mini pip",
        item: eventItems,
        pageType: BIA_PAGE_TYPE,
        section: NOT_APPLICABLE,
        sharedSection: sharedSection,
        target: ATC,
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

    window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.viewFullDetails', () => {
    const DDOEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: "buy it again: product quickview overlay: view full details button",
        }
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.floatingBarAddToCart', ({ output }) => {
    const { items = [], sharedSection, bulkCartAdd} = output
    const eventItems = items.map(item => ({
      displayPosition: NOT_APPLICABLE,
      productInfo: { sku: item.sku || '' }
    }));

    const DDOEvent = 
    {
      category: {
        primaryCategory: STASH,
      },
      eventInfo: {
        eventName: CART_ADD_RECS,
      },
      eventMode: STASH,
      stash: {
        component: 'product pod',
        bulkCartAdd: bulkCartAdd,
        item: eventItems,
        pageType: BIA_PAGE_TYPE,
        section: SECTION,
        sharedSection: sharedSection,
        target: ATC,
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.floatingBarUnselectAll', () => {
    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: "buy it again: floating bar: unselect all",
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};

